import './index.css';
import { Avatar, Popover, message } from 'antd';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import { USER_DATA } from '../../constants/ActionTypes';
import UtilLocalService from '../../services/localServiceUtil';
import { userSignOut, setSocketConnection, setSocket, updateUser, setNotificationCountList } from 'appRedux/actions/Auth';
import { FRANCHISEE_VISIBLE, GET_NOTIFICATION_COUNT, PAGE_PERMISSION, SOCKET_CONNECTION, USER_TYPES } from '../../constants/Common';
import { withApollo } from "react-apollo";
import { compose } from "recompose";
import IntlMessages from '../../util/IntlMessages';
const _ = require('lodash');
class UserProfile extends Component {
    state = {
        popoverVisible: false,
        isListenEvent: false,
        notificationCount: 0,
    }

    getActiveMenuStyle = (path) => {
        const updatedPathArray = path.split('/');
        const updatedPath = updatedPathArray.length === 4 ? '/' + updatedPathArray[2] + '/' + updatedPathArray[3] : '/' + updatedPathArray[2];
        let currentPath = this.props.pathname;
        const updatedCurrentPathArray = currentPath.split('/');
        const extraPath = updatedCurrentPathArray[3] ? `/${updatedCurrentPathArray[3]}` : '';
        const updatedCurrentPath = '/' + updatedCurrentPathArray[1] + '/' + updatedCurrentPathArray[2] + extraPath;
        if (updatedCurrentPath.includes(updatedPath)) {
            return 'slider-menu-bar active';
        }
        return 'slider-menu-bar';
    }

    closePopover = () => {
        this.setState({ popoverVisible: false });
    }

    handleVisibleChange = (value) => {
        this.setState({ popoverVisible: value, isListenEvent: value });
    };

    componentDidMount() {
        this.getNotification()
    }

    componentDidUpdate(prevProps) {
        if (this.state.isListenEvent) {
            this.getNotification()
        }
        if (!SOCKET_CONNECTION) {
            return;
        }
        if ((this.props.socket || this.props.socket !== prevProps.socket) && !this.state.isListenEvent) {
            this.props.socket.on('notificationUpdate', ({ data }) => {
                console.log("new notification", data)
                data && message.success(data.title);
                data && this.setState(prevState => {
                    return { notificationCount: prevState.notificationCount + 1 }
                })
            });
            this.props.socket.on('adminNotificationCount', ({ data }) => {
                console.log("notification count", data)
                data && this.setState({ notificationCount: data.count })
            });
            this.props.socket.emit('getAdminNotificationCount');
            this.props.socket.on('permissionChanged', ({ data }) => {
                const { authUser } = this.props;
                authUser.accessPermission = [];
                authUser.accessPermission = data;
                UtilLocalService.setLocalStorage('user', authUser);
                this.props.updateUser(authUser)
            });
            this.setState({ isListenEvent: true })
        }
    }

    getNotification = async () => {
        try {
            const { authUser } = this.props;
            let filter = { filter: { status: 1 } };
            console.log('authUser.type', authUser.type);
            if (authUser.type === USER_TYPES.FRANCHISEE && FRANCHISEE_VISIBLE) {
                filter.filter.franchiseeId = authUser.id;
            }
            const record = await this.props.client.query({
                query: GET_NOTIFICATION_COUNT,
                variables: filter,
                context: {
                    headers: {
                        authorization: `JWT ${this.props.token}`
                    }
                }
            });
            console.log("record shofasdgfskhgfsjhvfg", record);
            let data = record.data;
            if (data && data.getNotificationCount) {
                const { count = 0, pnCount = 0 } = data.getNotificationCount[0];
                this.props.setNotificationCountList({ notificationCount: count, pnCount: pnCount })
                this.setState({
                    notificationCount: count,
                    isListenEvent: false
                });
            } else {
                this.setState({
                    isListenEvent: false,
                    notificationCount: 0
                });
            }

        } catch (error) {
            console.log('Error****:', error.message);
        }
    };

    logout = async () => {
        if (SOCKET_CONNECTION) {
            await this.props.socket.disconnect();
        }
        this.props.userSignOut();
    }
    render() {
        const { authUser } = this.props;
        let menuPermission = authUser.accessPermission;
        let indexes = _.findIndex(menuPermission, { module: Number(PAGE_PERMISSION.NOTIFICATIONS) });
        let hasNotificationPermission =
            menuPermission[indexes] &&
            menuPermission[indexes].permissions &&
            menuPermission[indexes].permissions.list;
        const userMenuOptions =
            <ul className="gx-user-popover">
                <div className="tooltipPadding">
                    <li className={this.getActiveMenuStyle('/e-scooter/profile')}
                        onClick={this.closePopover.bind(this)}>
                        <Link to={`/e-scooter/profile`}><IntlMessages id="app.sidebar.myAccount" /></Link>
                    </li>
                    {hasNotificationPermission &&
                        <li onClick={this.closePopover.bind(this)} className="has_notification">
                            <Link to={`/e-scooter/notification`}><IntlMessages id="app.notification.notification" /><span className="tot">{this.state.notificationCount}</span></Link>
                        </li>
                    }
                    <li onClick={this.logout.bind(this)}><IntlMessages id="app.logout" />
                    </li>
                </div>
            </ul>;

        return (

            <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
                <Popover placement="rightTop" className="customPopover has_new" content={userMenuOptions}
                    onVisibleChange={this.handleVisibleChange} trigger="click" visible={this.state.popoverVisible}>
                    <Avatar src={authUser && authUser.image ? authUser.image : ''} icon="user" className="gx-size-40 gx-pointer gx-mr-3 " alt="" />
                    {hasNotificationPermission && this.state.notificationCount && this.state.notificationCount > 0 ?
                        <span className="has_new_dot"></span>
                        : null
                    }
                    <span className="gx-avatar-name"><IntlMessages id="app.hi" />, {authUser ? authUser.firstName : 'Loading'}</span>
                </Popover>
            </div>

        );

    }
}

const mapStateToProps = ({ auth }) => {
    const { authUser, socket, token } = auth;

    return { authUser, socket, token };
};

export default connect(mapStateToProps, { userSignOut, updateUser, setSocketConnection, setSocket, setNotificationCountList })(compose(withApollo)(UserProfile));
